/**
 * Shared layout constants for the graph explorer
 * Used by container creation, collapse/expand logic, and layout algorithms
 */

// Container header section heights
export const CONTAINER_LABEL_HEIGHT = 40 // Height reserved for label
export const CONTAINER_COVERAGE_BAR_HEIGHT = 16 // Height for link coverage bar + padding
export const CONTAINER_SEARCH_HEIGHT = 48 // Height for search input (36px content + 5px top/bottom margin)
export const CONTAINER_HEADER_HEIGHT =
  CONTAINER_LABEL_HEIGHT + CONTAINER_COVERAGE_BAR_HEIGHT + CONTAINER_SEARCH_HEIGHT
export const CONTAINER_ARTIFACT_LIST_TOP = CONTAINER_HEADER_HEIGHT

// Container styling
export const ACCENT_BAR_WIDTH = 10 // Width of the colored accent bar on container left side

// Artifact cell dimensions
export const ARTIFACT_LEFT_SECTION_WIDTH = 40
export const ARTIFACT_RIGHT_SECTION_WIDTH = 40
export const ARTIFACT_TOTAL_WIDTH = 400
export const ARTIFACT_MIDDLE_SECTION_WIDTH =
  ARTIFACT_TOTAL_WIDTH - ARTIFACT_LEFT_SECTION_WIDTH - ARTIFACT_RIGHT_SECTION_WIDTH
export const ARTIFACT_HEIGHT = 40
export const ARTIFACT_ROW_HEIGHT = 48 // 40px artifact + 8px gap

// Container artifact list
export const MAX_VISIBLE_ARTIFACTS = 10
export const CONTAINER_BOTTOM_PADDING = 22 // Inner top padding (16px) + ensures last item fully visible

// Highlighting styles (shared between element and link highlighting)
export const HIGHLIGHTED_STROKE_WIDTH = 4
export const HIGHLIGHTED_FILL = 'rgba(0, 0, 0, 0.05)'
export const HIGHLIGHTED_Z_INDEX = 10

// Selection state visuals
export const SELECTED_FILL = '#1a1a2e' // Dark/inverted background for selected node
export const SELECTED_TEXT_COLOR = '#ffffff' // White text on dark selected background
export const SELECTED_HOVER_FILL = '#2a2a4e' // Slightly lighter than SELECTED_FILL on hover

// Linked state visuals (neighbor of the selected node)
export const LINKED_FILL = 'rgba(0, 100, 255, 0.12)' // Subtle blue tint for linked nodes
export const LINKED_HOVER_FILL = 'rgba(0, 100, 255, 0.22)' // Brighter tint on hover

// Unlinked state visuals (no relation to selected node)
export const UNLINKED_OPACITY = 0.35 // Dimmed opacity for nodes unrelated to selection

// Link default styles
export const DEFAULT_LINK_STROKE_WIDTH = 2
export const DEFAULT_LINK_Z_INDEX = 3
export const DEFAULT_LINK_STROKE_COLOR = '#808080' // Gray — matches link-factory default
export const SELECTED_LINK_STROKE_COLOR = 'black' // Bold black when selected
